import { ReactElement } from 'react';

import {
  Popover,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { PopoverChildren } from '@beeline/design-system-react/types/components/Popover/Popover.types';

import styles from './styles.module.scss';

import { NORMAL_PLUS_SCREEN_WIDTH } from ':constants';
import { useWindowWidth } from ':hooks';

interface WidgetSmallPopoverProps {
  text: string;
  children: PopoverChildren;
}

export function WidgetSmallPopover({
  children,
  text,
}: WidgetSmallPopoverProps): ReactElement {
  const windowWidth = useWindowWidth();

  if (windowWidth <= NORMAL_PLUS_SCREEN_WIDTH) {
    return <>{children}</>;
  }

  return (
    <Popover
      popoverClassName={styles.popover}
      content={
        <Typography className={styles.tooltip} variant='caption'>
          {text}
        </Typography>
      }
    >
      {children}
    </Popover>
  );
}
